import { FeatureFlag } from '../FeatureFlag';

export const enableTradingOrderManagementFiltering = new FeatureFlag({
    key: 'enable-trading-order-management-filtering',
    createdOn: '2025-05-22',
    defaultValue: false,
});
